import React, { useEffect, useState } from "react";
import styles from "./History.module.css";
import ChatItem from "./ChatItem";
import clsx from "clsx";
import { showConsoleError } from "../../../../util/ConsoleMessage";
import {
  FAV_TAG,
  Prompt,
} from "../../../../api/responsePayload/PromptResponse";
import { GetPrompts } from "../../../../api/NodePromptApiCall";

interface HistoryProps {
  nodeName: string;
}

const History: React.FC<HistoryProps> = ({ nodeName }) => {
  const [prompts, setPrompts] = useState<Prompt[]>([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isAction, setActionUpdate] = useState(true);

  useEffect(() => {
    const fetchChat = async () => {
      try {
        const response = await GetPrompts(undefined, { node_name: nodeName });
        response?.results &&
          setPrompts(
            response.results.reverse().filter((item) => {
              if (!startDate && !endDate) return true;
              const itemDate = new Date(item.last_updated).getTime();
              const from = startDate
                ? new Date(startDate).getTime()
                : -Infinity;
              const to = endDate ? new Date(endDate).getTime() : Infinity;
              return itemDate >= from && itemDate <= to;
            })
          );
      } catch (error) {
        showConsoleError("Failed to fetch data:", error);
      }
      setActionUpdate(false);
    };

    if (isAction) {
      fetchChat();
    }
  }, [isAction]);

  const handleDefaultSelected = (prompt_id: number) => {
    setPrompts((prev) =>
      prev.map((item) => {
        return { ...item, is_default: item.id === prompt_id };
      })
    );
  };

  const handleFavSelected = (prompt_id: number) => {
    setPrompts((prev) =>
      prev.map((item) => {
        if (item.id == prompt_id) {
          if (item.tag === FAV_TAG) return { ...item, tag: null };
          else return { ...item, tag: FAV_TAG };
        }
        return item;
      })
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.dates_container}>
          <label>Start Date:</label>
          <input
            type="date"
            placeholder="dd/mm/yyyy"
            className={styles.date}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <label>-</label>
          <label>End Date:</label>
          <input
            type="date"
            value={endDate}
            placeholder="dd/mm/yyyy"
            className={styles.date}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <button className={clsx(styles.button)}> Search</button>
      </div>

      <div className={styles.chatList}>
        {prompts.length > 0 ? (
          prompts.map((chat) => (
            <ChatItem
              key={chat.id}
              chat={chat}
              onFavClicked={handleFavSelected}
              onDefaultClicked={handleDefaultSelected}
              setAction={(isAction) => setActionUpdate(isAction)}
            />
          ))
        ) : (
          <div className={styles.emptyMessage}>
            No prompts found for the selected date range.
          </div>
        )}
      </div>
    </div>
  );
};

export default History;
